// src/pages/ListPage.js
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../utils/axiosInstance';
import RoundRobinGame from '../components/RoundRobinGame';

const ListPage = () => {
  const { listId } = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    const fetchList = async () => {
      try {
        setErr('');
        setLoading(true);
        const res = await axios.get('/rankings');
        const found = (res.data || []).find((l) => String(l._id) === String(listId));
        if (!found) setErr('List not found');
        else setList(found);
      } catch (e) {
        console.error('Failed to load list', e);
        setErr('Failed to load list.');
      } finally {
        if (alive) setLoading(false);
      }
    };
    fetchList();
    return () => { alive = false; };
  }, [listId]);

  const items = useMemo(() => {
    if (!list) return [];
    return (list.items || []).map((title, idx) => ({
      id: `${list._id}:${idx}`,
      title,
    }));
  }, [list]);

  const handleComplete = async (finalOrder) => {
    try {
      const username = localStorage.getItem('username');
      const ranking = finalOrder.map((it) => it.title);
      // Server should upsert (overwrite) your previous ranking
      await axios.post('/rankings/submit', { listId: list._id, username, ranking });
    } catch (e) {
      console.error('Submit failed', e);
      // fallthrough — still go to detail
    }
    navigate(`/my-rankings/${list._id}`);
  };

  return (
    <div className="scroll-shell">
      <div className="scroll-body">
        <button className="logout-btn" onClick={() => navigate(-1)} style={{ marginBottom: 16 }}>
          ← Back
        </button>

        {loading && <div style={{color:'#666'}}>Loading list…</div>}
        {err && <div style={{color:'#b91c1c'}}>{err}</div>}

        {list && (
          <RoundRobinGame
            items={items}
            listTitle={list.listName}
            onComplete={handleComplete}
          />
        )}
      </div>
    </div>
  );
};

export default ListPage;
